import type { Signal } from '../../../../shared/types';
import { loadRoute, saveRoute, unwatched } from '../../data/corridor';
import { currentPosition } from '../../data/geocode';
import { appendStop, removeStop, stopForSignal } from '../../logic/signalActions';
import { whyText } from '../../logic/signalRank';
import { locationOf } from '../../logic/signals';
import { routeAnchor } from '../routeCommit';

/** Add + plan's second half (D74, D80): the business placed — by its own coordinates when the row has
 *  them, else on the map — and slotted into the day's route, on this device (D27). Null when it cannot
 *  be placed — no address, no connection, Maps down — and the lead is already safe either way. */
export const planStop = async (
  s: Signal,
  leadId: string,
): Promise<{ index: number; undo: () => void } | null> => {
  try {
    const own = locationOf(s);
    const [here, located] = await Promise.all([
      currentPosition(),
      own
        ? new Map([[s.id, own]])
        : new Map(),
    ]);
    const at = located.get(s.id);
    if (!at) return null;
    const route = loadRoute();
    const stop = stopForSignal(s, leadId, at, whyText(s));
    const anchor = route?.anchor ?? routeAnchor(here, stop);
    const next = appendStop(route, stop, anchor, new Date().toISOString());
    unwatched(saveRoute(next));
    return {
      index: next.stops.findIndex((x) => x.place_id === stop.place_id) + 1,
      undo: () => {
        const now = loadRoute();
        if (now) unwatched(saveRoute(removeStop(now, stop.place_id)));
      },
    };
  } catch {
    return null;
  }
};
